<template>
    <div>
      <Head title="Admin" />
      <v-container class="grey lighten-5">
        <v-card>
            <v-card-title>
                Admin
            </v-card-title>
        </v-card> 

      </v-container>
    </div>
  </template>
  
  <script>
  import { Head } from '@inertiajs/inertia-vue'
  import Layout from '@/Shared/VuetifyAdminLayout'
  import axios from 'axios'
  
  export default {
    props: {
    },
    components: {
      Head,
    },
    layout: Layout,
    data() {
        return {
            
        }
    },
    watch: {
    },
    created() {
    },
    methods: {
      
      
    },
  }
  </script>
  